import React from 'react';

/**
 * ErrorBoundary — catches any render error in the tree below it.
 * Placement: wrap <AppShell /> in App.js
 * Fixes: prevents blank white page on uncaught render errors.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || 'Unknown error' };
  }

  componentDidCatch(error, info) {
    // Replace console.error with your error monitoring (e.g. Sentry)
    // Sentry.captureException(error, { extra: info });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          role="main"
          style={{
            minHeight: '60vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
            textAlign: 'center',
            fontFamily: 'sans-serif',
          }}
        >
          <h1 style={{ fontSize: '1.5rem', color: '#0f172a', marginBottom: '1rem' }}>
            Something went wrong
          </h1>
          <p style={{ color: '#475569', marginBottom: '1.5rem', maxWidth: '36rem' }}>
            We encountered an unexpected error. Please try refreshing the page.
            If the problem persists, contact us at{' '}
            <a href="mailto:wecare@ourbroking.com" style={{ color: '#d97706' }}>
              wecare@ourbroking.com
            </a>
          </p>
          <a
            href="/"
            style={{
              padding: '0.75rem 1.5rem',
              background: '#f59e0b',
              color: '#0f172a',
              borderRadius: '999px',
              fontWeight: 700,
              textDecoration: 'none',
            }}
          >
            Go to Homepage
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;